package com.exura.features.newauth.domain.model

/**
 * Represents the current state of authentication.
 */
sealed class AuthState {
    /**
     * User authentication is in progress
     */
    object Loading : AuthState()

    /**
     * User is not authenticated
     */
    object Unauthenticated : AuthState()

    /**
     * User is authenticated with details about their account
     */
    data class Authenticated(val user: AuthUser) : AuthState()
}

/**
 * Extension function to check if the user is currently loading
 */
val AuthState.loading: Boolean
    get() = this is AuthState.Loading
